// extracted by mini-css-extract-plugin
export default {"playerContainer":"VideoPlayer_playerContainer__vibyj"};